import { DeleteOutlined } from "@ant-design/icons";
import { Button, Collapse, Input, notification, Typography } from "antd";
import { Robot } from "../assets";
import { ColumnComponent, RowComponent } from "../components";

import { useEffect, useState } from "react";

export const InvolvedAgentsPartial = ({
  initialAgents = [],
  onChangeAgents = (agents) => {
    console.log(agents);
  },
}) => {
  const [api, contextHolder] = notification.useNotification();

  const [agent, setAgent] = useState({
    agentName: "",
    objective: "",
    activity: "",
    inputs: "",
    outputs: "",
  });
  const [errors, setErrors] = useState({
    agentName: "",
    objective: "",
    activity: "",
    inputs: "",
    outputs: "",
  });
  const [capturedAgents, setCapturedAgents] = useState([]);

  const onSubmit = () => {
    ["agentName", "objective", "activity", "inputs", "outputs"].forEach(
      (key) => {
        if (!agent[key]) {
          errors[key] = `El campo ${key} no puede estar vacío.`;
          setErrors({ ...errors, [key]: errors[key] });
        } else {
          delete errors[key];
        }
      }
    );

    if (Object.keys(errors).length > 0) return;

    setCapturedAgents([
      ...capturedAgents,
      {
        key: `${capturedAgents.length + 1}`,
        label: agent.agentName,
        ...agent,
      },
    ]);

    onChangeAgents([
      ...capturedAgents,
      {
        key: `${capturedAgents.length + 1}`,
        label: agent.agentName,
        ...agent,
      },
    ]);

    setAgent({
      agentName: "",
      objective: "",
      activity: "",
      inputs: "",
      outputs: "",
    });

    api.info({
      message: "Agente guardado",
      description: "El agente ha sido guardado correctamente.",
      placement: "bottomRight",
      duration: 5,
      style: {
        borderRadius: "8px",
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
        backgroundColor: "#ffff",
      },
    });
  };

  const onDeleteAgent = ({ agent }) => {
    const editedAgents = capturedAgents.filter((a) => a !== agent);
    setCapturedAgents(editedAgents);
    onChangeAgents(editedAgents);
  };

  useEffect(() => {
    if (initialAgents?.length > 0) {
      setCapturedAgents([...initialAgents]);
    }
  }, [initialAgents]);

  return (
    <ColumnComponent>
      {contextHolder}
      <Typography.Title style={{ textAlign: "left" }} level={4}>
        Agentes Involucrados
      </Typography.Title>

      <ColumnComponent
        style={{
          marginBottom: "0.5rem",
          textAlign: "left",
          maxWidth: "50%",
        }}
      >
        <Typography.Title level={5} style={{ fontSize: "14px" }}>
          Nombre del agente
        </Typography.Title>

        <Input
          placeholder="Escriba nombre del agente"
          value={agent.agentName}
          onChange={(e) => setAgent({ ...agent, agentName: e.target.value })}
        />
        {errors.agentName && (
          <Typography.Text
            type="danger"
            style={{
              fontSize: "12px",
              marginTop: "0.5rem",
              textAlign: "left",
            }}
          >
            {errors.agentName}
          </Typography.Text>
        )}
      </ColumnComponent>

      <RowComponent style={{ gap: "1rem" }}>
        <ColumnComponent>
          <Typography.Title
            level={5}
            style={{
              marginBottom: "0.5rem",
              textAlign: "left",
              fontSize: "14px",
            }}
          >
            Objetivo
          </Typography.Title>

          <Input.TextArea
            placeholder="Escriba objetivo del agente"
            value={agent.objective}
            onChange={(e) => setAgent({ ...agent, objective: e.target.value })}
          />
          {errors.objective && (
            <Typography.Text
              type="danger"
              style={{
                fontSize: "12px",
                marginTop: "0.5rem",
                textAlign: "left",
              }}
            >
              {errors.objective}
            </Typography.Text>
          )}
        </ColumnComponent>

        <ColumnComponent>
          <Typography.Title
            level={5}
            style={{
              marginBottom: "0.5rem",
              textAlign: "left",
              fontSize: "14px",
            }}
          >
            Actividades
          </Typography.Title>

          <Input.TextArea
            placeholder="Escriba las actividades del agente"
            value={agent.activity}
            onChange={(e) => setAgent({ ...agent, activity: e.target.value })}
          />
          {errors.activity && (
            <Typography.Text
              type="danger"
              style={{
                fontSize: "12px",
                marginTop: "0.5rem",
                textAlign: "left",
              }}
            >
              {errors.activity}
            </Typography.Text>
          )}
        </ColumnComponent>
      </RowComponent>

      <RowComponent
        style={{
          gap: "1rem",
        }}
      >
        <ColumnComponent>
          <Typography.Title
            level={5}
            style={{
              marginBottom: "0.5rem",
              textAlign: "left",
              fontSize: "14px",
            }}
          >
            Inputs
          </Typography.Title>

          <Input.TextArea
            placeholder="Escriba los inputs del agente"
            value={agent.inputs}
            onChange={(e) => setAgent({ ...agent, inputs: e.target.value })}
          />
          {errors.inputs && (
            <Typography.Text
              type="danger"
              style={{
                fontSize: "12px",
                marginTop: "0.5rem",
                textAlign: "left",
              }}
            >
              {errors.inputs}
            </Typography.Text>
          )}
        </ColumnComponent>

        <ColumnComponent>
          <Typography.Title
            level={5}
            style={{
              marginBottom: "0.5rem",
              textAlign: "left",
              fontSize: "14px",
            }}
          >
            Output
          </Typography.Title>

          <Input.TextArea
            placeholder="Escriba los outputs del agente"
            value={agent.outputs}
            onChange={(e) => setAgent({ ...agent, outputs: e.target.value })}
          />
          {errors.outputs && (
            <Typography.Text
              type="danger"
              style={{
                fontSize: "12px",
                marginTop: "0.5rem",
                textAlign: "left",
              }}
            >
              {errors.outputs}
            </Typography.Text>
          )}
        </ColumnComponent>
      </RowComponent>
      <RowComponent
        style={{
          justifyContent: "flex-end",
          marginTop: "1rem",
        }}
      >
        <Button type="primary" onClick={() => onSubmit()}>
          Agregar agente
        </Button>
      </RowComponent>

      <Collapse
        expandIconPosition="end"
        defaultActiveKey={capturedAgents.map((_, index) => index)}
        style={{
          marginTop: "1rem",
        }}
      >
        {capturedAgents
          .slice()
          .reverse()
          .map((agent, index) => (
            <Collapse.Panel
              key={index}
              header={
                <RowComponent
                  style={{
                    textAlign: "left",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <Robot size={25} /> {agent.agentName}
                </RowComponent>
              }
              style={{ border: "1px solid #94a3b8", textAlign: "left" }}
            >
              <b>Objetivo:</b>
              <Typography.Paragraph>{agent.objective}</Typography.Paragraph>

              <b>Actividades: </b>
              <Typography.Paragraph>{agent.activity}</Typography.Paragraph>

              <b>Inputs: </b>
              <Typography.Paragraph>{agent.inputs}</Typography.Paragraph>

              <b>Outputs: </b>
              <Typography.Paragraph>{agent.outputs}</Typography.Paragraph>

              <RowComponent
                style={{
                  justifyContent: "flex-end",
                  marginTop: "1rem",
                }}
              >
                <Button
                  type="text"
                  icon={<DeleteOutlined style={{ color: "red" }} />}
                  shape="circle"
                  onClick={() => onDeleteAgent({ agent })}
                  style={{ color: "red" }}
                >
                  Eliminar
                </Button>
              </RowComponent>
            </Collapse.Panel>
          ))}
      </Collapse>
    </ColumnComponent>
  );
};
